import React, { useEffect, useContext, useCallback, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'
import Modal, { ModalProps } from '../../../components/bakery/Modal'
// import ModalTitle from '../../../components/bakery/ModalTitle'
import { Text } from 'rebass'
import { ButtonNewPrimary } from '../../../components/Button'
import { AutoRow } from '../../../components/Row'
import Loader from '../../../components/Loader'
import { stopPropagation } from '../../../utils/func'
import Value from '../../../components/Value/OnlyValue'
import useUnLockToken from '../../../hooks/nft/useUnLockToken'
import { SUPPORTTYPE } from '../../../constants/bakery/nft'
import { Input as NumericalInput } from '../../../components/NumericalInput'
import { BigNumber } from 'bignumber.js'

const SubTitle = styled.div`
  text-align: center;
  margin-top: 21px;
  margin-bottom: 12px;
`
const pointer ="POINTER"

const ChangeText = styled.div`
    background: ${({ theme }) => theme.bsBg37};
    display: flex;
    justify-content: space-between;
    width: 290px;
    height: 48px;
    margin: auto;
    border-radius: 10px;
    font-family: 'Roboto-Medium';
    align-items: center;
    padding: 0px 10px;
    position: relative;
    &>.${pointer}{
        position: absolute;
        left: 0px;
        right: 0px;
        margin: auto;
        text-align: center;
    }
`

const InitialPower = styled.div`
    font-size: 14px;
    width: 290px;
    margin: auto;
    margin-top: 24px;
    padding: 20px 0px 10px;
    border-top: 1px solid rgba(214,164,133, 0.3);
    color: ${({ theme }) => theme.bsText7};
    display: flex;
    align-items: center;
`

const InfoAmount = styled.div`
    position: relative;
`

const InputWrapper = styled.div`
    width: 290px;
    margin: 0px auto 70px;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.bsBg37};
    border: 0px;
    border-radius: 10px;
    height: 40px;
    padding: 0 16px;
    & > input {
        font-size: 18px;
        font-family: 'Roboto-Medium';
        color: ${({theme}) => theme.bsText34};
        ::placeholder {
            color: ${({ theme }) => theme.text4};
        }
    }
`
const MaxWrapper = styled.div`
    display:flex;
    flex-direction: column;
    position: absolute;
    top: 50px;
    margin: auto;
`

const MaxTokenAmount = styled.div`
    width: 290px;
    margin: auto;
    color: #DA4550;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: flex-end;
    font-size: 15px;
`

interface LockTokenModal extends ModalProps {
    tokenId: string
    title: string,
    tokenName: string,
    lockedCAR: number,
    stakingPower: number
}

const UnlockTokenModal: React.FC<LockTokenModal> = ({
    onDismiss,
    tokenId,
    title,
    tokenName,
    lockedCAR,
    stakingPower
}) => {
    const theme = useContext(ThemeContext)

    // 获取token余额
    const [tokenBalance, setTokenBalance] = useState(0)
    let bakeryBalance: any
    switch (tokenName) {
        case SUPPORTTYPE.CAR:
            bakeryBalance = lockedCAR
            break
    }
    useEffect(() => {
        const balanceFormat = new BigNumber(bakeryBalance).decimalPlaces(3,1).toNumber()
        setTokenBalance(balanceFormat)
      }, [bakeryBalance])

    // 是否显示最大数量
    const [requestedMaxAmount, setRequestedMaxAmount] = useState(false)

    // 输入token后能量值变化 changedPower
    const [tokenAmount, setTokenAmount] = useState('')
    const [changedPower, setChangedPower] = useState(0)
    const onUserInput = (val: string) => {
        // eslint-disable-next-line no-useless-escape
        const text: string = val.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')
        setTokenAmount(text)
        switch (tokenName) {
            case SUPPORTTYPE.CAR:
                setChangedPower(stakingPower - 100 * new BigNumber(text).toNumber())
                break
        }
        if(tokenBalance < +text){
            setRequestedMaxAmount(true)
        }else {
            setRequestedMaxAmount(false)
        }
    }

    // 确认解锁币
    const { onUnLockToken } = useUnLockToken(tokenId, tokenName, new BigNumber(tokenAmount).times(new BigNumber(10).pow(18)).toString(), SUPPORTTYPE.CAR)
    const [requestedConfirm, setRequestedConfirm] = useState(false)
    const handleUnLockToken = useCallback(
        async (event) => {
            try {
                stopPropagation(event)
                setRequestedConfirm(true)
                const txHash = await onUnLockToken()
                if (!txHash) {
                    setRequestedConfirm(false)
                    onDismiss && onDismiss()
                } else {
                    setTimeout(() => {
                        setRequestedConfirm(false)
                        onDismiss && onDismiss()
                    }, 10000)
                }
            } catch (e) {
                console.log(e)
            }
        },
        [setRequestedConfirm, onDismiss, onUnLockToken]
    )
    
    return (
        <Modal maxWidth={424} padding={'40px 59px 32px'} backgroundColor={theme.bsBg36}>
            {/* <ModalTitle text={title} /> */}
            <Text fontSize={20} fontFamily={'Roboto-Bold'} color={theme.bsText28} textAlign="center">{ title }</Text>
            <SubTitle>
                <Text fontSize={16} fontFamily={'Roboto-Bold'} color={theme.bsText28}>Staking Power</Text>
            </SubTitle>
            <ChangeText>
                <Text fontSize={26} color={theme.bsText34}>
                    <Value decimals={2} value={stakingPower} />
                </Text>
                <Text fontSize={20} fontWeight={400} color={theme.bsText34} className={pointer}>→</Text>
                <Text fontSize={26} color={theme.bsText34}>
                    {
                        changedPower ? (<Value decimals={2} value={changedPower} />) : '-'
                    }
                </Text>
            </ChangeText>
            <InitialPower>
            </InitialPower>
            <InfoAmount>
                <InputWrapper>
                    <NumericalInput
                        className="token-amount-input"
                        value={tokenAmount}
                        style={{ marginRight: 5}}
                        placeholder={'Input the number'}
                        maxLength={12}
                        onUserInput={val => {
                            onUserInput(val)
                        }}
                    />
                    <Text fontSize={16} fontFamily="Roboto-Medium" color={theme.bsText33}>{tokenName}</Text>
                </InputWrapper>
                <MaxWrapper>
                    {/* <MaxTokenAmount>
                        You will get:&nbsp;&nbsp;  
                        {
                            tokenAmount ? (
                            <Value decimals={3} value={new BigNumber(new BigNumber(tokenAmount).toNumber() * 0.99).decimalPlaces(3,1).toNumber()} />
                            ) : " - "
                        }
                        &nbsp;{tokenName}
                    </MaxTokenAmount> */}
                    <MaxTokenAmount>
                    1% fee will be taken when unlock
                    </MaxTokenAmount>
                    {
                        requestedMaxAmount ? (
                            <MaxTokenAmount>
                                Max:&nbsp;&nbsp;  
                                <Value decimals={2} value={tokenBalance} /> &nbsp;{tokenName}
                            </MaxTokenAmount>
                        ) : ""
                    }
                </MaxWrapper>
            </InfoAmount>
            <ButtonNewPrimary
                onClick={handleUnLockToken}
                disabled={requestedConfirm || !tokenAmount || requestedMaxAmount}
                fontSize={14}
                height={40}
                altDisabledStyle={requestedConfirm || !tokenAmount || requestedMaxAmount} // show solid button while waiting
                style={{
                    padding: '0',
                    width: '290px',
                    margin: 'auto'
                }}
            >
                {
                    requestedConfirm ? (
                        <AutoRow gap="6px" justify="center">
                            Confirmimg <Loader stroke="white" />
                        </AutoRow>
                    ) : (
                        'Confirm'
                    )
                }
            </ButtonNewPrimary>
        </Modal >
    )
}

export default UnlockTokenModal
